export default __webpack_public_path__ + "locales/ru/Ldap.json?hash=3afed62bda8b85013a2eef63a08c937c";